export default "/images/df6d32b0a9e6fef47e204c45afbe9700.avif";